function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
const ButtonBase = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    component: ButtonBaseRoot = 'button',
    children = null,
    onClick = null,
    className = null,
    unstyled = false,
    ...rest
  } = props;
  const styledButtonClasses = classNames('sui-btn-base', className);
  const classes = unstyled ? className : styledButtonClasses;
  const handleOnClick = event => {
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(ButtonBaseRoot, _extends({
    ref: ref,
    type: "button",
    onClick: handleOnClick,
    className: classes
  }, rest), children);
});
ButtonBase.displayName = 'ButtonBase';
ButtonBase.propTypes = {
  component: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  unstyled: PropTypes.bool,
  className: PropTypes.string
};
export { ButtonBase };
//# sourceMappingURL=ButtonBase.js.map